'use client';

import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { VXButtons } from '@/components/buttons/vxButtons';
import { Tag } from '@/components/tag';
const AddLabel = t0 => {
  const $ = _c(25);
  const {
    labels,
    onAdd,
    onClose
  } = t0;
  const [value, setValue] = useState("");
  let t1;
  if ($[0] !== labels || $[1] !== value) {
    t1 = value.trim() !== "" && !labels.includes(value);
    $[0] = labels;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isValid = t1;
  let t2;
  if ($[3] !== onAdd || $[4] !== onClose || $[5] !== value) {
    t2 = () => {
      onClose();
      onAdd(value);
    };
    $[3] = onAdd;
    $[4] = onClose;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const approve = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: "12px"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = value !== "" && !isValid;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      htmlInput: {
        "data-testid": "add-label-input"
      }
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => setValue(event.target.value);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== approve || $[11] !== isValid || $[12] !== onClose) {
    t7 = event_0 => {
      if (event_0.key === "Enter") {
        event_0.preventDefault();
        event_0.stopPropagation();
        if (isValid) {
          approve();
        }
      } else {
        if (event_0.key === "Escape") {
          event_0.preventDefault();
          event_0.stopPropagation();
          onClose();
        }
      }
    };
    $[10] = approve;
    $[11] = isValid;
    $[12] = onClose;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7 || $[16] !== value) {
    t8 = <TextField autoFocus={true} size="small" placeholder="Label" error={t4} slotProps={t5} value={value} onChange={t6} onKeyDown={t7} />;
    $[14] = t4;
    $[15] = t7;
    $[16] = value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = !isValid;
  let t10;
  if ($[18] !== approve || $[19] !== onClose || $[20] !== t9) {
    t10 = <VXButtons onApprove={approve} onCancel={onClose} approveDisabled={t9} />;
    $[18] = approve;
    $[19] = onClose;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <Stack direction="row" sx={t3}>{t8}{t10}</Stack>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};

/**
 * Metadata labels as removable chips with an inline add. Adding validates against the labels
 * already present, so the editor cannot produce a blank or repeated one and no caller needs to
 * gate a submit on its state.
 */
export const LabelsEditor = t0 => {
  const $ = _c(13);
  const {
    labels: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const labels = t2;
  const [adding, setAdding] = useState(false);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: "8px",
      flexWrap: "wrap"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== labels || $[4] !== onChange) {
    t4 = labels.map(label => <Tag key={label} variant="secondary" content={label} onRemove={() => onChange(labels.filter(other => other !== label))} />);
    $[3] = labels;
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== adding || $[7] !== labels || $[8] !== onChange) {
    t5 = adding ? <AddLabel labels={labels} onAdd={label_0 => onChange([...labels, label_0])} onClose={() => setAdding(false)} /> : <IconButton onClick={() => setAdding(true)} aria-label="Add label" data-testid="add-label-btn"><i className="material-symbols-add-rounded w-[20px] h-[20px] text-(--mui-palette-text-primary)" /></IconButton>;
    $[6] = adding;
    $[7] = labels;
    $[8] = onChange;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Stack direction="row" sx={t3}>{t4}{t5}</Stack>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};